import React, { createContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API_BASE_URL from "./config";
import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_WEBSITE_HMAC_SECRET_KEY;
// Create Context
export const DataContext = createContext();

function decryptData(encryptedBase64, ivBase64) {
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);

  
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedData },
        CryptoJS.enc.Utf8.parse(secretKey),
        { iv: iv,padding: CryptoJS.pad.Pkcs7}
      );
    
      // Convert the decrypted bytes back into a string
      const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedData;
  }


// Context Provider Component
export const DataProvider = ({ children }) => {
    const [isValidParam, setIsValidParam] = useState(false);
    const location = useLocation();    

    const [data, setData] = useState(() => {
        // Load data from sessionStorage on initialization
        const storedData = sessionStorage.getItem("apiData");
        return storedData ? JSON.parse(storedData) : null;
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Static bearer token from environment variables
    const bearerToken = process.env.REACT_APP_BEARER_TOKEN;

    // Check if the bearer token exists
    if (!bearerToken) {
        console.error("Bearer token is missing in environment variables.");
    }

    // Extract `q` parameter from URL
    const queryParam = new URLSearchParams(location.search).get("q");

    const suburl = `${API_BASE_URL}WsClusterSubscriptionPlans_v1.php?dashboard=${queryParam}`;

    useEffect(() => {          
        if (queryParam) {
        // Start loading state
        setLoading(true);

        // Fetch data from PHP API
        fetch(suburl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `bearer ${bearerToken}`,
            }
        })
            .then((response) => response.json())
            .then((result) => {
                // console.log("Response Data:", result);
                // Check if the API response contains errors
                const encryptedData = result.data;
                const iv = result.iv;
                const decryptedData = decryptData(encryptedData, iv);

                if (result.is_error) {
                    setIsValidParam(false);
                    setError(result.message || "Unknown error");
                    setData(null);
                    sessionStorage.removeItem("apiData");
                } else {
                    setIsValidParam(true);
                    const responseData = JSON.parse(decryptedData);
                    setData(responseData);
                    sessionStorage.setItem("apiData", JSON.stringify(responseData)); // Save to sessionStorage
                    setError(null); // Reset error if successful
                }
                setLoading(false);
            })
            .catch((error) => {
                setIsValidParam(false);
                console.error("Error fetching data:", error);
                setError("Failed to fetch data. Please try again later.");
                setData(null);
                sessionStorage.removeItem("apiData"); // Remove session data on fetch failure
                setLoading(false);
            });
        } else {
            setIsValidParam(false);
            // Handle the case where `q` is not present in the URL
            setError("Missing query parameter 'q'.");
            setLoading(false);
        }
    }, [queryParam, bearerToken, suburl]); // Dependency array ensures the effect runs when either `queryParam` or `bearerToken` changes

    return (
        <DataContext.Provider value={{ data, loading, error, isValidParam }}>
            {children}
        </DataContext.Provider>
    );
};